module.exports = __webpack_public_path__ + "static/scancore-logo 1-cee7de60cda7e1ca65a0590759b13471.svg";